// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ap-3";
export var contentContainer = "_ap-0";
export var editorContainer = "_ap-1";
export var quillInputForm = "_ap-2";
export var zoneDivider = "_ap-4";